import Backbone from 'backbone';

export default Backbone.Model.extend({
  default: {
    id: '',
    name: '',
    className: '',
    icon: '',
    isActive: false
  },

  startRecordingState() {
    if (this.get('className')) {
      const commands = editor.Commands;
      let commandName = 'recordState';
      let command = commands.get(commandName);
      let options = {
        command: commandName
      };
      commands.runCommand(command, { ...options, sender: this });
    }
  },

  stopRecordingState() {
    if (this.get('className')) {
      const commands = editor.Commands;
      let commandName = 'recordState';
      let command = commands.get(commandName);
      let options = {
        command: commandName
      };
      commands.stopCommand(command, { ...options, sender: this, force: 1 });
    }
  }
});
